import 'bootstrap/dist/css/bootstrap.min.css'; 
import hii from '../assets/img/hii.gif'
import Navbar from './NavBar.js'
import Roll from 'react-reveal/Roll';

function AboutHeroSection() {
    return (
        <div className="sec6 container">
            <Navbar />
            <h2>About me</h2>
            <Roll left>
            <div className="row aboutSection">
              <div className="col">
                <p>
                    Nice to meet you stranger !<br></br>
                    I am Software Engineer. I love Technology and Designs.
                </p>
              </div>
              <div className="col">
              <img src={hii} alt="line" />
              </div>
            </div>
            </Roll>
          </div>
        );
    }
    
export default AboutHeroSection;